import { gql, useQuery } from '@apollo/client';
import { useRetry } from '../../hooks/useRetry';
import { handleError } from '../../utils/errorHandling';
export const FETCH_RESUME_SUBSCRIPTION_PROPERTIES = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchResumeSubscriptionProperties\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"0-69\",\"block\":false}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PaymentsSubscription\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"unpauseBillingInformation\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"earliestBillingDate\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"proposedNextBillingDate\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"statusAfterUnpause\"}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "FetchResumeSubscriptionProperties"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "StringValue",
            value: "0-69",
            block: false
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "PaymentsSubscription"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "unpauseBillingInformation"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "earliestBillingDate"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "proposedNextBillingDate"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "statusAfterUnpause"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export function isResumeSubscriptionQueryValid(data) {
  var _data$crmObject;
  return Boolean((data === null || data === void 0 || (_data$crmObject = data.crmObject) === null || _data$crmObject === void 0 ? void 0 : _data$crmObject.__typename) === 'PaymentsSubscription' && data.crmObject.unpauseBillingInformation);
}
export function useResumeSubscriptionQuery(objectId) {
  var _unpauseBillingInform, _unpauseBillingInform2, _ref;
  const query = useQuery(FETCH_RESUME_SUBSCRIPTION_PROPERTIES, {
    variables: {
      objectId
    },
    fetchPolicy: 'network-only'
  });
  const startRetrying = useRetry({
    retry: () => {
      query.refetch().catch(handleError);
    },
    shouldRetry: () => Boolean(!isResumeSubscriptionQueryValid(query.data) || query.error),
    onFailedAfterRetries: () => {
      throw new Error('useResumeSubscriptionQuery failed to finish loading after retries');
    }
  });
  if (query.loading) {
    return Object.assign({}, query, {
      data: null
    });
  }
  if (!query.data) {
    return Object.assign({}, query, {
      data: null
    });
  }
  if (!isResumeSubscriptionQueryValid(query === null || query === void 0 ? void 0 : query.data) || query.error) {
    startRetrying();
    return Object.assign({}, query, {
      data: null
    });
  }
  const {
    crmObject: {
      unpauseBillingInformation
    }
  } = query.data;
  return Object.assign({}, query, {
    data: {
      earliestBillingDate: (_unpauseBillingInform = unpauseBillingInformation === null || unpauseBillingInformation === void 0 ? void 0 : unpauseBillingInformation.earliestBillingDate) !== null && _unpauseBillingInform !== void 0 ? _unpauseBillingInform : 0,
      proposedNextBillingDate: (_unpauseBillingInform2 = unpauseBillingInformation === null || unpauseBillingInformation === void 0 ? void 0 : unpauseBillingInformation.proposedNextBillingDate) !== null && _unpauseBillingInform2 !== void 0 ? _unpauseBillingInform2 : 0,
      statusAfterUnpause: (_ref = unpauseBillingInformation === null || unpauseBillingInformation === void 0 ? void 0 : unpauseBillingInformation.statusAfterUnpause) !== null && _ref !== void 0 ? _ref : ''
    }
  });
}